<template>
  <div class="search-ai-form card">
    <el-form ref="form" :model="{ prompt }" label-width="80px" class="search-ai-form" @submit.prevent="">
      <el-form-item label="Prompt">
        <el-input v-model="prompt" type="textarea" :rows="6"
          placeholder="Enter search prompt, e.g. 'Find all kayaking teams in London'" clearable />
      </el-form-item>

      <div class="search-ai-form__actions">
        <el-button @click="onReset">Reset</el-button>
        <el-button type="primary" native-type="submit" @click="onSearch" :disabled="isButtonDisabled('search-ai')">
          Search
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { searchAIPrompt } from '@/api/ai.js';
import { parseErrorsByFields } from '@/utils/index.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'SearchAIForm',
  mixins: [disableButton],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      prompt: this.modelValue || '',
      errors: {},
    };
  },
  watch: {
    modelValue(val) {
      if (val !== this.prompt) this.prompt = val;
    },
    prompt(val) {
      this.$emit('update:modelValue', val);
    },
  },
  computed: {
    searchFormData() {
      return {
        prompt: (this.prompt || '').trim(),
      };
    },
  },
  methods: {
    parseErrorsByFields,
    showMessage,
    async onSearch() {
      this.disableButton('search-ai');
      const { searchFormData } = this;
      const { data, success, errors } = await searchAIPrompt(searchFormData);
      this.enableButton('search-ai');

      if (success) {
        this.$emit('receive-data', data);
      } else if (errors) {
        this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
      }
    },
    onReset() {
      this.$emit('update:modelValue', '');
      this.$emit('reset');
    },
  },
};
</script>

<style scoped>
.search-ai-form {
  max-width: 800px;
}

.search-ai-form__bottom {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.search-ai-form__subtitle {
  margin-top: 0;
}

.search-ai-form__actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
</style>
